import {useQuery} from '@apollo/react-hooks';
import gql from 'graphql-tag';
import {POLL_INTERVAL} from '../../constants';
import {GroupBooking} from '../../graphql/groups.datatypes';

interface GroupBookingData {
    myGroupBooking?: void
    groupBooking: GroupBooking
}

export const gqlRoomPartyMember = `
    id
    room_party_id
    group_member_id
    billing_party_id
    primary_occupant
    guest_number
    start_date
    end_date

    cost
    totalPayments
    outstandingBalance

    groupMember {
        id
        first_name
        last_name
        dob
        tour_role
    }

    billingParty {
        id
        payingMembers {
            id
            email
            first_name
            last_name
            primary_paying_member
        }
    }

    options(trashed: WITH) {
        id
        group_resource_option_id
        unit_count
        unit_cost
        admin_edited
        deleted_at

        groupResourceOption {
            id
            resource_option_id

            option {
                id
                internal_name
            }
        }
    }
`;

export const gqlGroupBooking = `
    id
    group_id
    soft_cancelled
    disabled
    start_date
    end_date
    created_at
    cost
    outstandingBalance
    overduePayments
    admin_locked

    group {
        id
        name
        description
        credit_card_fee
        hotel_resource_id
        booking_form_url

        hotel {
            id
            internal_name
        }
    }

    billingParties {
        id
        group_booking_id
        credit_card_fee
        soft_cancelled
        disabled
        cost
        outstandingBalance
        overduePayments
        credit_card_fee_paid

        primaryPayingMember {
            id
            email
        }

        payingMembers{
            id
            primary_paying_member
            first_name
            last_name
            email
            address_line_1
            address_line_2
            city
            state
            zipcode
            country
            primary_phone
            primary_phone_code
            secondary_phone
            secondary_phone_code
            notes
            billing_party_id
        }

        members {
            id
            billing_party_id
            group_member_id
            cost
        }
    }

    roomParties {
        id
        group_booking_id
        hotel_resource_id
        disabled
        start_date
        end_date
        wheelchair_access
        has_infants
        notes

        hotel {
            id
            internal_name

            roomResources {
                id
                internal_name
            }
        }

        roomResource {
            id
            room_resource_id
        }

        options {
            id
            room_party_id
            group_resource_option_id
            unit_count
            unit_cost
            admin_edited

            groupResourceOption {
                id
                resource_option_id

                option {
                    id
                    internal_name
                }
            }
        }

        members {
            ${gqlRoomPartyMember}
        }
    }
`;

export const GET_GROUP_BOOKING_QUERY = gql`
    query groupBooking($id: Int!){
        groupBooking(id: $id){
          ${gqlGroupBooking}
        }
    }
`;

export const getGroupBooking = (partyId: number | null, poll: boolean = true) => {
    const id = partyId ? partyId : -1;
    return useQuery<GroupBookingData>(
        GET_GROUP_BOOKING_QUERY,
        {
            fetchPolicy: 'no-cache',
            variables: {id},
            pollInterval: poll ? POLL_INTERVAL : undefined,
        }
    );
};

export default getGroupBooking;
